// store/index.ts
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './auth';
import http from './http';
import catalog from './catalog';
import catalogConfig, { CatalogConfigState} from './catalog/config';
import pedidos from './pedidos';
import orders from './orders';
import email from './email';
import transito from './transito';
import permisos from './permisos';

const store = createStore({
  modules: {
    auth,
    http,
    catalog,
    orders,
    pedidos,
    email,
    catalogConfig,
    transito,
    permisos,
  },
  plugins: [
    createPersistedState({
      paths: ['auth'] // Specify the modules to persist their state
    })
  ]
});

export default store;